import { getStorage, ref,uploadBytes, getDownloadURL } from "firebase/storage";

export const UploadImages = ({
  file,
  callback,
  extension
  } : {
  file: File | Blob,
  callback?: (url: string) => void
  extension?: string
}) => {
  const storageRef = getStorage();
  if(!extension && file instanceof File) {
    extension = file.name.split('.').pop();
  }
  if(!extension) {
    extension = 'png';
  }
  const id = (Date.now()) + "_" + (Math.random().toString(36).substring(7));
  const imagesRef = ref(storageRef, 'images/' + id + '.' + extension);
  uploadBytes(imagesRef, file).then((snapshot) => {
    getDownloadURL(snapshot.ref).then(url => {
      console.log(url);
      callback && callback(url);
    });
  });
}